import React, { useContext, useState } from 'react';
import {
  Typography,
  Grid,
  Stack,
  Box,
  Button,
  useMediaQuery,
} from '@mui/material';
import { poppins500 } from 'theme/common.style';
import RequestDepositPaymentPopup from '../RequestDepositPaymentPopup';
import { useTheme } from '@emotion/react';
import { datacontext } from 'modules/AppLayout/AppLayout';

const RequestIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4062 19.2H18.3281C18.5437 18.475 18.6875 17.75 18.6875 17.025C18.6875 13.4 15.8125 10.5 12.2188 10.5C8.625 10.5 5.75 13.4 5.75 17.025C5.75 17.75 5.89375 18.475 6.10938 19.2H5.03125C4.6 19.2 4.3125 19.49 4.3125 19.925C4.3125 20.36 4.6 20.65 5.03125 20.65H13.5125H17.1781H19.3344C19.7656 20.65 20.0531 20.36 20.0531 19.925C20.0531 19.49 19.8375 19.2 19.4062 19.2ZM7.1875 17.025C7.1875 14.1975 9.41563 11.95 12.2188 11.95C15.0219 11.95 17.25 14.1975 17.25 17.025C17.25 17.75 17.1062 18.5475 16.7469 19.2H14.6625C14.6625 19.1275 14.6625 19.055 14.6625 18.9825C14.6625 17.895 13.8 17.025 12.7219 17.025H11.5C11.2125 17.025 10.9969 16.8075 10.9969 16.5175C10.9969 16.2275 11.2125 16.01 11.5 16.01H13.8719C14.3031 16.01 14.5906 15.72 14.5906 15.285C14.5906 14.85 14.3031 14.56 13.8719 14.56H12.9375V14.125C12.9375 13.69 12.65 13.4 12.2188 13.4C11.7875 13.4 11.5 13.69 11.5 14.125V14.6325C10.4938 14.705 9.70312 15.5025 9.70312 16.5175C9.70312 17.605 10.5656 18.475 11.6438 18.475H12.8656C13.1531 18.475 13.3688 18.6925 13.3688 18.9825C13.3688 19.055 13.3687 19.1275 13.2969 19.2H7.7625C7.33125 18.5475 7.1875 17.75 7.1875 17.025Z"
        fill="#ffff"
      />
      <path
        d="M2.15625 11.9501C2.73125 11.9501 3.30625 11.7326 3.66562 11.2976C4.025 10.9351 4.24062 10.5001 4.3125 9.9926L5.75 10.3551C5.89375 10.4276 6.10938 10.4276 6.25312 10.4276C6.68437 10.4276 7.04375 10.2826 7.40313 10.0651L12.2188 7.0201L15.5969 9.8476C15.9563 10.1376 16.4594 10.3551 16.9625 10.3551C17.1063 10.3551 17.3219 10.3551 17.4656 10.2826L19.6219 9.7026C19.8375 9.6301 20.0531 9.4126 20.125 9.1951C20.1969 8.9776 20.125 8.6876 19.9094 8.4701L13.8719 2.3801C13.4406 2.0176 12.9375 1.8001 12.3625 1.8001H4.16875C3.88125 0.930098 3.09063 0.350098 2.15625 0.350098C0.934375 0.350098 0 1.2926 0 2.5251V9.7751C0 11.0076 0.934375 11.9501 2.15625 11.9501ZM12.8656 3.4676L18.0406 8.6876L17.1062 8.9051C16.8906 8.9776 16.675 8.9051 16.4594 8.7601L12.7219 5.6426C12.65 5.5701 12.65 5.5701 12.5781 5.5701C12.5781 5.5701 12.5781 5.5701 12.5062 5.5701C12.4344 5.4251 12.2906 5.4251 12.2188 5.4251H7.1875C6.75625 5.4251 6.46875 5.7151 6.46875 6.1501C6.46875 6.5851 6.75625 6.8751 7.1875 6.8751H9.70312L6.6125 8.8326C6.46875 8.9051 6.25312 8.9776 6.0375 8.9051L4.3125 8.4701V3.2501H12.3625C12.5063 3.2501 12.7219 3.3226 12.8656 3.4676ZM1.4375 2.5251C1.4375 2.0901 1.725 1.8001 2.15625 1.8001C2.5875 1.8001 2.875 2.0901 2.875 2.5251V9.0501V9.7751C2.875 9.9926 2.80312 10.1376 2.65937 10.2826C2.51562 10.4276 2.37188 10.5001 2.15625 10.5001C1.725 10.5001 1.4375 10.2101 1.4375 9.7751V2.5251Z"
        fill="#ffff"
      />
    </svg>
  );
};

const ArrowWhiteIocn = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.17934 8.19976L18.5856 1.9904C18.6448 1.96776 18.7092 1.96275 18.7712 1.97596C18.8332 1.98917 18.89 2.02005 18.9348 2.06486C18.9796 2.10966 19.0105 2.16649 19.0237 2.22846C19.0369 2.29043 19.0319 2.35491 19.0093 2.41409L12.7999 18.8203C12.7752 18.8826 12.732 18.9359 12.6762 18.9729C12.6203 19.01 12.5545 19.029 12.4875 19.0275C12.4205 19.026 12.3555 19.004 12.3014 18.9644C12.2473 18.9249 12.2065 18.8698 12.1847 18.8064L9.42024 11.9941C9.38801 11.8976 9.33377 11.8099 9.2618 11.7379C9.18983 11.6659 9.10211 11.6117 9.00557 11.5794L2.19328 8.81745C2.12911 8.7961 2.0731 8.75544 2.03292 8.70103C1.99274 8.64663 1.97036 8.58113 1.96883 8.51352C1.96731 8.4459 1.98671 8.37946 2.02439 8.3233C2.06208 8.26713 2.11619 8.22398 2.17934 8.19976Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8691 2.13281L9.3125 11.6895"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const DetailsMiddleContent = (props) => {
  const {
    depositDetailsData,
    buyerId,
    getDetailsData,
    getTableData,
    isFromBuyerRegister,
    profileDetails,
    getListInfo,
    manageOfferClick,
    fromVendorStatus,
    handleCloseDetails,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const DepositsCommonData = depositDetailsData?.depositDetails;
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const DetailsTitle = {
    fontSize: matchessm ? '12px' : '14px',
    color: '#666666',
    fontFamily: 'Poppins !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    color: '#1E1E1E',
  };
  const DetailsValue = {
    fontFamily: 'poppins',
    fontSize: matchessm ? '14px' : '16px',
    color: '#000000',
    fontWeight: 500,
  };
  const DetailsValueAmount = {
    fontFamily: 'poppins',
    fontSize: matchessm ? '18px' : '20px',
    color: '#000000',
    fontWeight: 500,
  };

  const [openRequestDeposit, setOpenRequestDeposit] = useState(false);

  const binderId = depositDetailsData?.depositDetails?.binderId;

  const OpenBinderChat = (currentBinder) => {
    if (currentBinder) {
      setShowMessage(true);
      setMessagedata({ binderId: currentBinder });
    }
  };

  return (
    <>
      {depositDetailsData?.depositDetails?.status == 'Overdue' ? (
        <Grid
          item
          container
          spacing={matchessm ? 0 : 3}
          sx={{
            border: '1px solid #fff',
            borderRadius: '20px',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
            p: 3,
            backgroundColor: '#fff',
            mt: '20px',
            // maxWidth: "944px",
            ml: 1,
          }}
        >
          <Grid item xs={12} md={5.5}>
            <Stack
              gap={4}
              flexDirection={'row'}
              alignItems={'center'}
              width={'100%'}
            >
              <Stack spacing={3} flexDirection={'column'}>
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Requested Deposit Amount</Box>
                  <Box sx={DetailsValueAmount}>
                    {DepositsCommonData?.requestedAmountFormatted ?? '-'}
                  </Box>
                </Stack>
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Requested Date</Box>
                  <Box sx={DetailsValue}>
                    {DepositsCommonData?.requestedDate ?? '-'}
                  </Box>
                </Stack>
              </Stack>
              <Stack spacing={3} flexDirection={'column'}>
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Amount Paid</Box>
                  <Box sx={DetailsValueAmount}>
                    {DepositsCommonData?.amountPaidFormatted ?? '-'}
                  </Box>
                </Stack>
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Due Date</Box>
                  <Box sx={DetailsValue}>
                    {DepositsCommonData?.dueDate ?? '-'}
                  </Box>
                </Stack>
              </Stack>
            </Stack>

            <Stack sx={{ mt: 2.5 }}>
              <Stack spacing={1}>
                <Box sx={DetailsTitle}>Viewed Status</Box>
                <Box
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '14px' : '16px',
                    color: '#000000',
                    fontWeight: 500,
                  }}
                >
                  {DepositsCommonData?.viewedStatus ?? '-'}
                </Box>
              </Stack>
            </Stack>
          </Grid>

          <Grid item container xs={12} md={6.5}>
            <Grid
              item
              container
              flexDirection={'column'}
              justifyContent={'space-between'}
            >
              <Grid item>
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Amount Unpaid</Box>
                  <Box
                    sx={{
                      fontFamily: 'poppins',
                      fontWeight: 500,
                      fontSize: matchessm ? '18px' : '20px',
                      color: '#EA4342',
                    }}
                  >
                    {DepositsCommonData?.amountUnPaidFormatted ?? '-'}
                  </Box>
                </Stack>
              </Grid>
              <Grid item>
                <Stack
                  direction={matchessm ? 'column' : 'row'}
                  justifyContent={'space-between'}
                  spacing={matchessm && '5px'}
                  mt={matchessm && '10px'}
                >
                  <Button
                    onClick={() => {
                      handleCloseDetails();
                      OpenBinderChat(binderId);
                    }}
                    startIcon={<ArrowWhiteIocn />}
                    sx={{
                      p: matchessm ? '10px 10px' : '10px 39px',
                      bgcolor: '#4CA4D6',
                      width: matchessm ? '100%' : '215px',
                      '&:hover': {
                        bgcolor: '#4CA4D6',
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins500,
                        color: '#FFFFFF',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                      }}
                    >
                      Send Reminder
                    </Typography>
                  </Button>
                  <Button
                    startIcon={<RequestIcon />}
                    onClick={() => setOpenRequestDeposit(true)}
                    disabled={
                      profileDetails?.PropertyDetails?.isArchived === 1 ||
                      Number(DepositsCommonData?.offerPrice || 0) ===
                        Number(DepositsCommonData?.requestedAmount || 0)
                    }
                    sx={{
                      p: matchessm ? '5px 10px' : '10px 39px',
                      bgcolor: '#4CA4D6',
                      width: matchessm ? '100%' : '215px',
                      '&:hover': {
                        bgcolor: '#4CA4D6',
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins500,
                        color: '#FFFFFF',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                      }}
                    >
                      Request Top Up
                    </Typography>
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          container
          sx={{
            border: '1px solid #ffffff',
            borderRadius: '20px',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
            p: 3,
            backgroundColor: '#fff',
            mt: '20px',
          }}
        >
          {/* Left Column */}
          <Grid item xs={12} sm={4}>
            <Stack spacing={3}>
              <Stack spacing={1}>
                <Box sx={DetailsTitle}>Requested Deposit Amount</Box>
                <Box sx={{ ...poppins500, fontSize: '20px', color: '#000000' }}>
                  {DepositsCommonData?.requestedAmountFormatted ?? '-'}
                </Box>
              </Stack>
              <Stack spacing={1}>
                <Box sx={DetailsTitle}>Requested Date</Box>
                <Box sx={{ ...poppins500, fontSize: '16px', color: '#000000' }}>
                  {DepositsCommonData?.requestedDate ?? '-'}
                </Box>
              </Stack>
            </Stack>
          </Grid>

          {/* Middle Column */}
          <Grid item xs={12} sm={5}>
            <Stack spacing={3}>
              <Stack direction="row" spacing={8}>
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Amount Paid</Box>
                  <Box
                    sx={{ ...poppins500, fontSize: '20px', color: '#000000' }}
                  >
                    {DepositsCommonData?.amountPaidFormatted ?? '-'}
                  </Box>
                </Stack>
                {/* {DepositsCommonData?.status !== "Transferred" && ( */}
                <Stack spacing={1}>
                  <Box sx={DetailsTitle}>Amount Unpaid</Box>
                  <Box
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: matchessm ? '18px' : '20px',
                      color: '#EA4342',
                    }}
                  >
                    {DepositsCommonData?.amountUnPaidFormatted ?? '-'}
                  </Box>
                </Stack>
                {/* )} */}
              </Stack>

              <Stack spacing={1}>
                <Box sx={DetailsTitle}>Viewed Status</Box>
                <Box
                  sx={{
                    ...poppins500,
                    fontSize: matchessm ? '14px' : '16px',
                    color: '#000000',
                  }}
                >
                  {DepositsCommonData?.viewedStatus ?? '-'}
                </Box>
              </Stack>
            </Stack>
          </Grid>

          {/* Right Column  */}
          <Grid
            item
            xs={12}
            sm={3}
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <Button
              startIcon={<RequestIcon />}
              disabled={
                profileDetails?.PropertyDetails?.isArchived === 1 ||
                Number(DepositsCommonData?.offerPrice || 0) ===
                  Number(DepositsCommonData?.requestedAmount || 0)
              }
              onClick={() => setOpenRequestDeposit(true)}
              sx={{
                p: '10px 25px',
                bgcolor: '#4CA4D6',
                '&:hover': {
                  bgcolor: '#4CA4D6',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#4CA4D6',
                  color: '#fff',
                  opacity: 0.7,
                  cursor: 'not-allowed',
                  pointerEvents: 'auto',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#FFFFFF',
                  fontSize: '14px',
                  textTransform: 'none',
                  fontWeight: 500,
                  fontFamily: 'poppins',
                }}
              >
                Request Top Up
              </Typography>
            </Button>
          </Grid>
        </Grid>
      )}

      <RequestDepositPaymentPopup
        openRequestDeposit={openRequestDeposit}
        setOpenRequestDeposit={setOpenRequestDeposit}
        depositDetailsData={depositDetailsData}
        buyerId={buyerId}
        getDetailsData={getDetailsData}
        fromMiddleContent={true}
        getTableData={getTableData}
        isFromBuyerRegister={isFromBuyerRegister}
        profileDetails={profileDetails}
        getListInfo={getListInfo}
        manageOfferClick={manageOfferClick}
        fromVendorStatus={fromVendorStatus}
      />
    </>
  );
};

export default DetailsMiddleContent;
